<div [class.isPrinting]="reportService.isPrinting">
  <nb-layout>
    <nb-layout-column  style="padding: 0;">
      <router-outlet></router-outlet>
    </nb-layout-column>
  </nb-layout>
</div>


<!-- Reporting Router -->
<div>
    <router-outlet name="reports"></router-outlet>
</div>
